import React from "react";
import Intro from "./About/Intro";

const UmaAbout = () => {
  return (
    <div style={{ width: "100%", margin: "auto" }}>
      <Intro/>
    </div>
  );
};

export default UmaAbout;
